import api from "./api";
import { useEffect, useState } from "react";
import { useUserSuperEmpresa } from "../Context/AuthContext";

export const useProfesional = () => {
    const { Token } = useUserSuperEmpresa();

     const getProfesional = async (params = {}) => {
    try {
      const { data } = await api.get("/all/profesional/clinicos", { 
        params,
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        }
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al obtener ingresos";
    }
  };

   const postProfesional = async (params = {}) => {
    try {
      const { data } = await api.post("/crear/profesional/clinicos", params, {
        headers: {
          Authorization: `Bearer ${Token}`, // enviamos token
        },
      });
      return data.data;
    } catch (error) {
      throw error.response?.data?.message || "Error al crear ingreso";
    }
  };

   const editarProfesional = async (id, params = {}) => {
    try {
      const { data } = await api.put(`/editar/profesional/clinicos/${id}`, params, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al editar el usuario";
    }
  };

   const eliminarProfesional = async (id) => {
    try {
      const { data } = await api.delete(`/eliminar/profesional/clinicos/${id}`, {
        headers: { Authorization: `Bearer ${Token}` },
      });
      return data;
    } catch (error) {
      throw error.response?.data?.message || "Error al eliminar el usuario";
    }
  };

   return { getProfesional,  postProfesional, editarProfesional, eliminarProfesional };
}


export const useGetProfesional = () => {
  const { Token } = useUserSuperEmpresa();
  const {getProfesional } = useProfesional();
  const [profesional, setprofesional] = useState([]);
  const [loadings, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProfesional = async () => {
    setLoading(true);
    try {
      const data = await getProfesional();
      setprofesional(data);
    } catch (err) {
      setError(err.response?.data?.message || "Error al obtener sucursales");
    } finally {
      setLoading(false);
    }
  };

  // Cargar al montar
  useEffect(() => {
    if (Token)fetchProfesional();
  }, [Token]);

  // ✅ Retorna la función refetch
  return { profesional, loadings, error, refetch:fetchProfesional };
};